import { render, staticRenderFns } from "./subSelect.vue?vue&type=template&id=1170004f&scoped=true&"
import script from "./subSelect.vue?vue&type=script&lang=ts&"
export * from "./subSelect.vue?vue&type=script&lang=ts&"
import style0 from "./subSelect.vue?vue&type=style&index=0&id=1170004f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1170004f",
  null
  
)

export default component.exports